import { ITEM_CATALOG } from './itemCatalog.js';

/**
 * ARAM-relevant shop buyables (no jungle/GP10/ward clutter).
 * Every craft component of a listed tree item must also be listed.
 */
export const ARAM_SHOP_ITEM_IDS = Object.freeze([
  'dorans_blade',
  'long_sword',
  'dagger',
  'boots_of_speed',
  'noonquiver',
  'kraken_slayer',
  'health_potion',
  'cloak_of_agility',
  'pickaxe',
  'infinity_edge',
  'galeforce',
  'immortal_shieldbow',
  'liandrys_anguish',
  'everfrost',
  'cloth_armor',
  'amplifying_tome',
  'control_ward'
]);

export function isAramBuyable(itemId) {
  return ARAM_SHOP_ITEM_IDS.includes(itemId);
}

/** Shop rows for ARAM / product client. */
export function getAramShopCatalog() {
  const catalog = {};
  for (const id of ARAM_SHOP_ITEM_IDS) {
    const def = ITEM_CATALOG[id];
    if (def) catalog[id] = def;
  }
  return catalog;
}

/** Items with a non-empty recipe (craft trees). */
export function listAramCraftTrees(catalog = getAramShopCatalog()) {
  return Object.values(catalog)
    .filter((item) => item.components && item.components.length > 0)
    .map((item) => ({
      id: item.id,
      name: item.name,
      cost: item.cost,
      components: [...item.components]
    }));
}

/**
 * Ensures every recipe component is itself an ARAM shop buyable.
 * @returns {{ ok: boolean, missing: Array<{ itemId: string, componentId: string }> }}
 */
export function validateAramShopTrees(catalog = getAramShopCatalog()) {
  const missing = [];
  for (const item of Object.values(catalog)) {
    for (const componentId of item.components || []) {
      if (!catalog[componentId]) {
        missing.push({ itemId: item.id, componentId });
      }
    }
  }
  return { ok: missing.length === 0, missing };
}
